var map = {
	"./Group 326.svg": "3bc7",
	"./accumulator.svg": "b45e",
	"./battery.svg": "04ee",
	"./bg-yellow.svg": "04ff",
	"./biometano.svg": "55db",
	"./cone.svg": "8a9f",
	"./down-chevron.svg": "d5b5",
	"./earth.svg": "b830",
	"./electric-gear.svg": "7914",
	"./email.svg": "9055",
	"./facebook.svg": "aaa3",
	"./gas-natural.svg": "23b9",
	"./green-energy.svg": "2221",
	"./green-power.svg": "cff3",
	"./house.svg": "d44b",
	"./icon-arrow.svg": "5d09",
	"./instagram.svg": "54e6",
	"./light-bulb.svg": "ac7d",
	"./linkedin.svg": "953d",
	"./logo-horizontal.svg": "5e52",
	"./logo-white-horizontal.svg": "d270",
	"./logo-white-vertical.svg": "5cb2",
	"./logo-white.svg": "f295",
	"./logo.svg": "9b19",
	"./menu-icon.svg": "9605",
	"./phone.svg": "001e",
	"./placas.svg": "bf3e",
	"./postes.svg": "17e6",
	"./recycle.svg": "c34b",
	"./renewable-energy.svg": "97ad",
	"./second-section-bg.svg": "600d",
	"./solar.svg": "0407",
	"./water-energy.svg": "84b3",
	"./whatsapp.svg": "3357"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";